var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgForward(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 -71 71 71",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M55.8105-35.2539C55.8105-36.9629 55.1758-38.3789 53.8574-39.6973L24.5605-68.6523C23.4863-69.7266 22.2168-70.2637 20.6543-70.2637C17.4805-70.2637 14.9414-67.7734 14.9414-64.6484C14.9414-63.0859 15.625-61.6699 16.748-60.5469L42.3828-35.2539L16.748-9.96094C15.625-8.83789 14.9414-7.42188 14.9414-5.85938C14.9414-2.73438 17.4805-0.244141 20.6543-0.244141C22.168-0.244141 23.4863-0.78125 24.5605-1.85547L53.8574-30.8105C55.2246-32.1289 55.8105-33.5449 55.8105-35.2539Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForward);
export default __webpack_public_path__ + "static/media/forward.cfd1d90b.svg";
export { ForwardRef as ReactComponent };